

const React = require('react');
import Avatar from '@material-ui/core/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import { IconButton, Typography, Icon, Button } from '@material-ui/core';


export class BottomBar extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showUserInfo: false,
      }
   }

   render(){
      return(
         <nav className='navbar fixed-bottom bottom-nav-bar'>
            <Button href='/faq' style={{color:'white'}}>
               <FontAwesomeIcon icon={['fas', "info-circle"]} transform="left-5 grow-3"/>
               <Typography  style={{marginRight:'40px',fontSize:'13px'}}>FAQ</Typography>
            </Button>
            <Button href='https://youtube.com/playlist?list=PLMWeUn2JOkX6j41JBdhgmXC16bW5uOrwF' target={'_blank'} style={{color:'white'}}>
               <FontAwesomeIcon icon={['fab', "youtube"]} transform="left-5 grow-3"/>
               <Typography style={{marginRight:'10px',fontSize:'14px'}}>TUTORIALS</Typography>
            </Button>
            <span className={'copyright-container'}>
               <span>
                  © 2024 POLYPLEXUS HOLDINGS LLC |
                  <a href={'https://www.herzogschindler.com/projects/polyplexus'} target={'_blank'}>
                     An H&S Venture
                  </a>
                  |
                  <a href={'https://s3-us-west-2.amazonaws.com/plexus-static/PolyplexusUserAgreement.pdf'} target={'_blank'}>
                     PRIVACY POLICY & TERMS
                  </a>

               </span>

            </span>
         </nav>
      );
   }
}
